import { render, staticRenderFns } from "./MerchantsForm.vue?vue&type=template&id=31d4a840&scoped=true&"
import script from "./MerchantsForm.vue?vue&type=script&lang=js&"
export * from "./MerchantsForm.vue?vue&type=script&lang=js&"
import style0 from "./MerchantsForm.vue?vue&type=style&index=0&id=31d4a840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4a840",
  null
  
)

export default component.exports